import 'ui-core/widgets/publication-content/js/publication-content';
import 'ui-core/components/coolbar/js/coolbar';
import 'element-closest-polyfill';
import 'core-js/es/array/map';
import GetFTR from '../../../components/getFTR/js/getFTR';

let videoList,
    audioList,
    videoInfoArr = [];

const article = document.querySelector('article'),
    isGetFTRReferencesEnabled = article?.getAttribute('data-getFTR-references-enabled');

UX.loader.load.related = function () {};

UX.loader.load.references = function () {};

UX.loader.load.figures = function () {};

UX.loader.getContentSuccess = function ($elem) {
    if ($elem === 'related') {
        const relatedPane = document.getElementById('pane-pcw-related');
        relatedPane?.setAttribute('aria-hidden', 'false');
        UX.accordion?.logic($('#pane-pcw-related .accordion-tabbed'));
    }

    if ($elem === 'details') {
        if ($('.tooltip').length) {
            UX.tooltip.init();
        }

        UX.loader.crossMarkAccessibility();
        UX.loader.altMetricLoader();
    }

    if ($elem === 'figure' && $('#pane-pcw-figures').find('.cloudflare-stream-player').length) {
        $.getScript(UX.loader.cloudFlareScript);
    }

    if ($elem === 'figure') {
        videoList = document.querySelectorAll('#pane-pcw-figures .figure__video .cloudflare-stream-player');
        audioList = document.querySelectorAll('#pane-pcw-figures .figure__audio audio');
        UX.loader.videoMedia(videoList, 'figureTab');
        UX.loader.audioMedia(audioList);
        document.addEventListener('figureTabTypeset', UX.utils.mathOnlyFallbackViewer);
    }

    if ($elem === 'references') {
        const jsScrollTab = $('.js--scrollTab');
        if (jsScrollTab.length) {
            UX.tab.on.select.external(jsScrollTab);
        }
    }

    UX.loader.showAudioSupportMsg();
    UX.loader.streamErrorHandler('#pane-pcw-figures');
    if (window.location.href.includes('utm')) {
        UX.utm.setElements();
        UX.utm.init();
    }

    let tabContent = document.querySelector('.tabs__wrapper .tab__content'),
        contentLoaded = tabContent?.querySelector('.active:not(#pane-pcw-related)');

    if (
        contentLoaded?.innerHTML.includes('mathrm') ||
        contentLoaded?.innerHTML.includes('textrm') ||
        contentLoaded?.innerHTML.includes('math')
    ) {
        const applyMathJax = setInterval(() => {
            if (contentLoaded.hasChildNodes()) {
                MathJax.typesetPromise([tabContent])
                    .then(() => {
                        clearInterval(applyMathJax);
                        document.dispatchEvent(new Event('figureTabTypeset'));
                    })
                    .catch(err => console.log(err.message)); // eslint-disable-line no-console
            }
        }, 2000);
    }
};

function referencesBottom($this) {
    const referencesLink = $this.data('references');

    if (isGetFTRReferencesEnabled) {
        const dataDoiElements = document.querySelectorAll('.getFTR .data-doi');
        const getFTR = new GetFTR();
        dataDoiElements && UX.loader.removeGetFTRElement(dataDoiElements);
        getFTR.articleReferences($this[0]);
    }

    if (!$('.article-section__references:has(.getFTR) .accordion__control').hasClass('clicked')) {
        $.get(referencesLink)
            .done(function (html) {
                $('.article-section__references:has(.getFTR) .accordion__control').addClass('clicked');
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log('error occure on the server ' + errorThrown); // eslint-disable-line no-console
            });
    }
}

UX.loader.additionalController = function () {
    var lang = null,
        langParent = null,
        $this = null,
        $wSlideContent = null,
        $accordion = null,
        cloudFlareScript = null;
    const $body = $('body');

    UX.loader.abstractLangs();

    UX.loader.referencesHash();

    UX.utils.menuRoleButton();

    $body.one('click ', '.related-tab', function (e) {
        if (UX.loader.related !== undefined) {
            // check if related' service url has been defined
            UX.loader.element = UX.loader.related;
            UX.loader.target = UX.loader.tabRelated;
            if (UX.loader.isArticleTabEmpty($(this))) {
                // check if figures panes is empty
                UX.loader.load.articleTab(
                    UX.loader.related,
                    UX.loader.relatedTab,
                    UX.loader.tabRelated,
                    'related',
                    false,
                    false
                ); // get related content
                $(UX.loader.target).removeClass('empty');
                UX.accordion.hideAllBoolean = false;
            }
            $('.creative-work .meta').truncate({
                lines: 1,
            });
        }
    });

    $body.on('focus', '.related-tab', function (e) {
        if (!UX.loader.isMobile) {
            $(this).trigger('click');
        }
    });

    $body.one('click', '.references-tab', function (e) {
        if (UX.loader.isArticleTabEmpty($(this))) {
            const referencesAccordion = Array.from(
                document.querySelectorAll('.article-section__references .article-accordion')
            );
            const referencesPane = document.getElementById('pane-pcw-references');
            let referencesSectionsBulk = [];

            referencesAccordion?.forEach(accordion => {
                const accordionTitleText = accordion.querySelector('.section__title')?.textContent;
                const referencesList = accordion?.querySelector('.accordion__content > ul');
                let titleEl = '';

                if (accordionTitleText?.toLowerCase() !== 'references') {
                    titleEl = `<h3 class="ref-heading">${accordionTitleText}</h3>`;
                }
                const referencesSection = `<div class="separator references-tab__collection">${titleEl}${referencesList?.outerHTML}</div>`;
                referencesSectionsBulk.push(referencesSection);
            });

            const referencesPaneContent = `<div class="separator">${referencesSectionsBulk.join('')}</div>`;
            referencesPane.insertAdjacentHTML('beforeend', referencesPaneContent);

            if (isGetFTRReferencesEnabled) {
                const dataDoiElements = document.querySelectorAll('.getFTR .data-doi');
                const getFTR = new GetFTR();
                dataDoiElements && UX.loader.removeGetFTRElement(dataDoiElements);
                getFTR.referencesTab();
            }
        }
    });

    $body.on('focus', '.references-tab', function (e) {
        if (!UX.loader.isMobile) {
            $(this).trigger('click');
        }
    });

    document.querySelector('#article_Ctrl')?.addEventListener('mousedown', e => {
        e.preventDefault();
    });

    $body.one('click', '.figures-tab', function (e) {
        if (UX.loader.figure !== undefined) {
            // check if related' service url has been defined
            UX.loader.element = UX.loader.figure;
            UX.loader.target = UX.loader.tabFigure;
            if (UX.loader.isArticleTabEmpty($(this))) {
                // check if figures panes is empty
                UX.loader.load.articleTab(
                    UX.loader.figure,
                    UX.loader.figuresTab,
                    UX.loader.tabFigure,
                    'figure',
                    false,
                    false
                ); // get figure content
                $(UX.loader.target).removeClass('empty');
            }
            setTimeout(function () {
                UX.loader.captionTruncate(
                    '.tab__content figcaption.figure__caption .figure__caption',
                    5,
                    'show',
                    'hide'
                );
            }, 1000);
        }
    });

    $body.on('focus', '.figures-tab', function (e) {
        if (!UX.loader.isMobile) {
            $(this).trigger('click');
        }
    });

    $(document).on('click', '.abstract-group .article-section__abstract .lang', function (e) {
        e.preventDefault();

        $('.article-row-left').height('auto');

        lang = $(this).data('lang-of');
        langParent = $(this)
            .closest('.abstract-group')
            .find('[data-lang=' + lang + ']');

        const abstractElements = document.querySelectorAll('[id^="abstract-graphical-"]'),
            abstractParentHolder = document.querySelector('.abstract-group'),
            abstractLanguages = abstractParentHolder.querySelectorAll('[id^="section-"]');

        abstractElements?.forEach(element => {
            const id = element?.id;
            id !== `abstract-graphical-${lang}` ? (element.style.display = 'none') : (element.style.display = 'unset');
        });

        abstractLanguages?.forEach(element => {
            const sectionLanguage = element.getAttribute('lang');
            sectionLanguage === lang ? (element.style.display = 'block') : (element.style.display = 'none');
        });

        $('.lang').removeClass('active');
        langParent.find('[data-lang-of=' + lang + ']').addClass('active');
        langParent.show();

        if ($('.article-row-left').outerHeight() < $(window).outerHeight()) {
            $('.article-row-left').height($(window).outerHeight() - $('header').outerHeight());
        }
        UX.coolbar.holder.empty();
        UX.coolbar.init();
    });

    $(document).on('click', '.figure-viewer .figureLink, .figure-viewer .bibLink', function () {
        $('.figure-viewer__ctrl__close').trigger('click');
    });

    $body.on('click', '.bibLink', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(this),
            $articleRowRight = $('.article-row-right'),
            $rootArticle = $articleRowRight.closest('article');

        if (!$this.hasClass('js--scrollTab')) {
            $rootArticle.find('.js--scrollTab').removeClass('js--scrollTab');
            $this.addClass('js--scrollTab');
        }

        if (UX.loader.isMobile) {
            const $slideBackBtn = $('.w-slide__back');

            $slideBackBtn.addClass('js--bib');
        }

        const referenceLink = e.target?.getAttribute('href');
        const referenceTarget = referenceLink?.slice(1);
        const tabReferenceItem = document.querySelector(
            `.references-tab__collection li[data-bib-id=\'${referenceTarget}\']`
        );
        tabReferenceItem?.setAttribute('tabindex', '0');
        tabReferenceItem?.focus();
    });

    $(document).on('click', '.back-to-article', function () {
        let $this = $(this),
            dataBackTo = $this.data('back-to'),
            articleTarget = $('.js--scrollTab[href="' + dataBackTo + '"]');

        articleTarget.focus();
        $this.removeClass('js--show');
    });

    $(window).on('load', function () {
        if ($('.coolBar').length && $('.w-slide').length) {
            $('.w-slide').addClass('padding-top');
        }

        $('.hideOnJSLoad').remove();
        $('.showOnJSLoad').removeClass('showOnJSLoad');
        //LIT-188190
        $('.coolBar--accessDenail .accordion-tabbed__control').on('click', function (e) {
            if (!$(this).hasClass('external')) {
                e.preventDefault();
                e.stopPropagation();
                $(this).next('.accordion-tabbed__content').toggle();
                $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
                $(this).parent('.accordion-tabbed__tab').toggleClass('js--open');
            }
        });
    });

    $('.figures-tab').on('click', function () {
        UX.loader.captionTruncate('.tab__content figcaption.figure__caption .figure__caption', 5, 'show', 'hide');
    });

    $body.on('click', '.more', function () {
        UX.loader.captionShowMore($(this));
        return false;
    });

    $body.on('click', '.less', function () {
        UX.loader.captionShowLess($(this));
        return false;
    });

    if ($('.corrections-label').length > 0) {
        const dataLabel = $('.corrections-container').hasClass('article-related') ? 'Article(s)' : 'Correction(s)';

        $('.corrections-body > ul').addClass('corrections-list');
        $('.corrections-label').addClass('w-slide__btn').attr({
            'data-slide-target': '.corrections-body',
            'data-label': dataLabel,
        });
    }

    $body.on('click', '.article-section__references:has(.getFTR) .accordion__control:not(.js--open)', function (e) {
        referencesBottom($(this));
    });

    $(window).load(function () {
        var url = window.location.href;
        var splitURL = url.split('#');
        var referencesSection = splitURL[1];
        if (referencesSection === 'references-section') {
            $('.article-section__references:has(.getFTR) .accordion__control:not(.js--open)').first().click();
        }
    });

    $(document).on('click', '.w-slide .accordion-tabbed__tab:not(.js--open)', function (e) {
        if ($(this).children('.author-name').length) {
            $this = $(this);
            $wSlideContent = $this.closest('.w-slide__content');
            $accordion = $this.closest('.accordion-tabbed');
            window.setTimeout(function () {
                if (
                    $wSlideContent.outerHeight() < $this.position().top + $this.outerHeight() ||
                    $wSlideContent.scrollTop() > $this.position().top - $accordion.position().top
                ) {
                    $wSlideContent.animate(
                        {
                            scrollTop: $this.position().top - $accordion.position().top,
                        },
                        250
                    );
                }
            }, 500);
        }
    });

    $(document).on('click', '.skip-links a', function (e) {
        var $item = $(this),
            itemDataSkip = $item.attr('href'),
            $skipTarget = $('.article-row ' + itemDataSkip);

        if ($skipTarget.length > 1) {
            e.preventDefault();
            if ($skipTarget.closest().is('.transplanted-clone')) {
                return false;
            }
            $(window).scrollTop($skipTarget.offset().top);
            $skipTarget.focus();
        }
    });

    $(window).on('load', function () {
        var $supportInfoSection = $(document).find('#support-information-section'),
            $supportInfoAccordion = $supportInfoSection.closest('.accordion__control');

        if (
            window.location.href.indexOf('#support-information-section') > 0 &&
            $supportInfoSection.length &&
            !$supportInfoAccordion.hasClass('js--open')
        ) {
            $supportInfoSection.trigger('click');
        }

        $('.article-section__table thead').each(function (index, thead) {
            var $headRow = $(thead).children(),
                stickyHeight = 0;

            if ($headRow.length > 1) {
                $headRow.each(function (index, tr) {
                    var $th = $(tr).find('th'),
                        trHeight = $(tr).outerHeight();
                    if (index !== 0) {
                        $th.css('top', stickyHeight);
                    }
                    stickyHeight += trHeight;
                });
            }
        });

        if ($('#gs-casa-r').length) {
            $('#gs-casa-r').css('z-index', '10');
        }
    });

    if ($('.fixedCoolBar').length) {
        UX.loader.fixedCoolBar();

        $(window).on('scroll resize', function () {
            UX.loader.fixedCoolBar();
        });
    }

    if ($('.seamlessAccessDenial__wrapper').length) {
        setTimeout(UX.loader.seamlessAccessDelay, 5000);
    }

    window.addEventListener('load', () => {
        const tooltipEl = UX.utils.convertToArray(document.querySelectorAll('.tooltip'));
        if (tooltipEl.length) {
            UX.tooltip.init();
        }

        const mobileDetailsTabWrapper = document.querySelector('.w-slide--list'),
            mobileDetailsTab = mobileDetailsTabWrapper?.querySelector('.details-tab');

        if (mobileDetailsTab || UX.loader.isMobile) {
            UX.loader.load.articleTab(UX.loader.details, UX.loader.detailsTab, UX.loader.tabDetails, 'details');
        }
    });

    const articleAdvertSection = document.querySelector('.articleAdvert'),
        bottomAdEl = articleAdvertSection?.querySelector('.advert-rail'),
        fakeFocusableEl = '<div class="sr-only js--adFocusableEl" aria-hidden="true" tabindex="-1"></div>';

    bottomAdEl?.insertAdjacentHTML('afterend', fakeFocusableEl);

    const supportInformationSection = document.querySelector('.article-section__supporting');
    if (supportInformationSection) {
        const supportInformationSectionData = supportInformationSection.dataset.suppl,
            supportInformationAccordion = supportInformationSection.querySelector('.accordion__control'),
            showSupplOnClick = e => {
                if (!e.currentTarget.dataset.triggered) {
                    e.currentTarget.dataset.triggered = 'true';
                    if (supportInformationSectionData) {
                        fetch(supportInformationSectionData).then(() => false);
                    }
                }
            },
            showSupplOnKeydown = e => {
                if (e.key === 'Enter') {
                    if (!e.currentTarget.dataset.triggered) {
                        e.currentTarget.dataset.triggered = 'true';
                        if (supportInformationSectionData) {
                            fetch(supportInformationSectionData).then(() => false);
                        }
                    }
                }
            };

        if (supportInformationAccordion) {
            supportInformationAccordion.addEventListener('click', showSupplOnClick);
            supportInformationAccordion.addEventListener('keydown', showSupplOnKeydown);
        }
    }

    videoList = document.querySelectorAll('#article__content .figure__video .cloudflare-stream-player');
    audioList = document.querySelectorAll('#article__content .figure__audio audio');
    cloudFlareScript = document.querySelector('.cloudFlareScript')?.value;

    UX.loader.showAudioSupportMsg();
    UX.loader.streamErrorHandler('.article__content');
    UX.loader.fixedToolbarPosition();
    UX.loader.setTPRAriaLabel();
    UX.loader.audioMedia(audioList);

    const cloudFlareInterval = setInterval(function () {
        UX.loader.videoMedia(videoList);

        if (cloudFlareScript) {
            clearInterval(cloudFlareInterval);
        }
    }, 3000);
};

UX.loader.videoMedia = function (videoList, source) {
    if (videoList.length) {
        let videoStartTime = 0,
            videoPlayingPeriod = 0;

        const videoListArr = Array.from(videoList),
            streamEvents = ['playing', 'pause', 'seeking', 'waiting', 'ended', 'stalled'],
            streamAnalysis = (event, videoId, videoElement, videoObject) => {
                const figureVideoElement = videoElement.closest('.figure__video'),
                    trackMediaUrlElement = figureVideoElement.querySelector('.track-media-url');

                if (trackMediaUrlElement) {
                    const trackMediaUrlData = trackMediaUrlElement.value,
                        videoAutoplay = videoObject.autoplay,
                        videoCurrentTime = videoObject.currentTime,
                        eventType = event.type;

                    if (eventType === 'playing') {
                        videoStartTime = videoCurrentTime;
                    }

                    videoCurrentTime > 0
                        ? (videoPlayingPeriod = videoCurrentTime - videoStartTime)
                        : ((videoStartTime = 0), (videoPlayingPeriod = 0));

                    if (source === 'figureTab') {
                        videoInfoArr.map(item =>
                            item.videoId === videoId ? (item.videoTime = videoCurrentTime) : item
                        );
                    }

                    if (trackMediaUrlData && typeof videoObject.currentTime !== 'undefined') {
                        switch (eventType) {
                            case 'pause':
                                if (videoObject.currentTime === videoObject.duration) return false;
                                break;
                        }
                        const url = `${trackMediaUrlData}&mediaEventType=${eventType}&mediaPosition1=${videoCurrentTime}&mediaPlayingPeriod=${videoPlayingPeriod}&autoplay=${videoAutoplay}`;
                        fetch(url).then(() => false);
                    }
                }

                return false;
            },
            onBrowserClose = (event, videoObject, videoElement) => {
                if (videoObject.currentTime > 0 && !videoObject.paused && !videoObject.ended) {
                    const figureVideoElement = videoElement.closest('.figure__video'),
                        trackMediaUrlEl = figureVideoElement.querySelector('.track-media-url'),
                        trackMediaUrlData = trackMediaUrlEl.value,
                        videoAutoplay = videoObject.autoplay,
                        videoCurrentTime = videoObject.currentTime,
                        eventType = 'pause';

                    videoPlayingPeriod = videoCurrentTime - videoStartTime;

                    let url = trackMediaUrlData
                        ? `${trackMediaUrlData}&mediaEventType=${eventType}&mediaPosition1=${videoCurrentTime}&mediaPlayingPeriod=${videoPlayingPeriod}&autoplay=${videoAutoplay}`
                        : '';
                    fetch(url).then(() => false);
                }
            };

        videoListArr.forEach((video, index) => {
            const videoElement = video,
                videoObject = Stream(videoElement),
                videoId = index;

            video.setAttribute('title', 'Video');

            if (source === 'figureTab' && videoInfoArr.filter(item => item.videoId === videoId).length === 0) {
                videoInfoArr.push({
                    videoId: videoId,
                    videoTime: videoObject.currentTime,
                });
            } else if (source === 'figureViewer') {
                videoInfoArr.map(item =>
                    item.videoId === videoId ? (videoObject.currentTime = item.videoTime) : item
                );
            }

            streamEvents.forEach(ev => {
                videoObject.addEventListener(ev, event => {
                    streamAnalysis(event, videoId, videoElement, videoObject);
                });
            });

            window.addEventListener('beforeunload', event => {
                onBrowserClose(event, videoObject, videoElement);
            });
        });
    }
};

UX.loader.audioMedia = function (audioList) {
    if (audioList.length) {
        let audioStartTime = 0,
            audioPlayingPeriod = 0;

        const streamEvents = ['playing', 'pause', 'seeking', 'waiting', 'ended', 'stalled'],
            streamAnalysis = e => {
                const figureAudioElement = e.target.closest('.figure__audio'),
                    trackMediaUrlEl = figureAudioElement.querySelector('.track-media-url');

                if (trackMediaUrlEl) {
                    const trackMediaUrlData = trackMediaUrlEl.value,
                        audioAutoplay = e.target.autoplay,
                        eventType = e.type,
                        audioCurrentTime = e.target.currentTime;

                    if (eventType === 'playing') {
                        audioStartTime = audioCurrentTime;
                    }

                    audioCurrentTime > 0
                        ? (audioPlayingPeriod = audioCurrentTime - audioStartTime)
                        : ((audioStartTime = 0), (audioPlayingPeriod = 0));

                    if (trackMediaUrlData && typeof e.target.currentTime !== 'undefined') {
                        switch (eventType) {
                            case 'pause':
                                if (e.target.currentTime === e.target.duration) return false;
                                break;
                        }
                        const url = `${trackMediaUrlData}&mediaEventType=${eventType}&mediaPosition1=${audioCurrentTime}&mediaPlayingPeriod=${audioPlayingPeriod}&autoplay=${audioAutoplay}`;
                        fetch(url).then(() => false);
                    }
                }
            },
            onBrowserClose = () => {
                audioList.forEach(audio => {
                    if (audio.currentTime > 0 && !audio.paused && !audio.ended) {
                        const figureAudioElement = audio.closest('.figure__audio'),
                            trackMediaUrlEl = figureAudioElement.querySelector('.track-media-url'),
                            trackMediaUrlData = trackMediaUrlEl.value,
                            eventType = 'pause',
                            audioAutoplay = audio.autoplay,
                            audioCurrentTime = audio.currentTime;

                        audioPlayingPeriod = audioCurrentTime - audioStartTime;

                        let url = trackMediaUrlData
                            ? `${trackMediaUrlData}&mediaEventType=${eventType}&mediaPosition1=${audioCurrentTime}&mediaPlayingPeriod=${audioPlayingPeriod}&autoplay=${audioAutoplay}`
                            : '';
                        fetch(url).then(() => false);
                    }
                });
            };

        audioList.forEach(audio => {
            streamEvents.forEach(ev => {
                audio.addEventListener(ev, streamAnalysis);
            });
        });

        window.addEventListener('beforeunload', onBrowserClose);
    }
};

UX.loader.setTPRAriaLabel = function () {
    const $body = $('body');

    if ($body.find('.tpr__link').length) {
        let $tprLink = $body.find('.tpr__link'),
            tprHost = $tprLink[0].host,
            tprAriaLabel = tprHost.split('.')[0];
        $tprLink.attr('aria-label', tprAriaLabel);
    }
};

UX.loader.abstractLangs = function () {
    var tmp = [];
    var ids = [];
    var langNames = [];
    var $abs = $('.abstract-group .article-section__abstract');

    //$abs.addClass('active');
    $('.article-section__abstract:not(#abstract-graphical-)').hide();

    const observer = new MutationObserver((mutationsList, observer) => {
        const element = document.querySelector('.lang.active');
        if (element) {
            const activeLanguage = element.getAttribute('hreflang');
            const abstractGraphicalCurrent = document.getElementById(`abstract-graphical-${activeLanguage}`);
            abstractGraphicalCurrent && (abstractGraphicalCurrent.style.display = 'block');

            observer.disconnect();
        }
    });
    observer.observe(document, {childList: true, subtree: true});

    $abs.each(function () {
        if ($(this).find('.lang').length) {
            // check if we have tow abs with the same lang
            for (let i = 0; i <= tmp.length; i++) {
                if (tmp[i] === $(this).find('.lang').html()) {
                    $(this).find('.lang').remove();
                    return;
                }
            }

            tmp.push($(this).find('.lang').html());
            ids.push($(this).attr('id'));
            langNames.push(
                $(this).attr('lang-name')?.includes(';')
                    ? $(this).attr('lang-name').split(';')[0]
                    : $(this).attr('lang-name')
            );
            $(this).find('.lang').remove();
            $(this).find('.article-section__header').after("<div class='lang-container'></div>");
        }
    });

    if (tmp.length <= 1) {
        $('.lang-container').remove();
        $('.article-section__abstract').show();
    }

    for (let i = 0; i < tmp.length; i++) {
        $('.lang-container').append(
            "<a class='lang' href='#" +
                ids[i] +
                "' hreflang='" +
                tmp[i] +
                "' data-lang-of='" +
                tmp[i] +
                "'>" +
                tmp[i] +
                '<span>This link goes to a ' +
                langNames[i] +
                ' section</span></a>'
        );
    }

    $('.lang').show();
    $abs.find('.lang:first-child').addClass('active').show();
    $('.article-section__abstract[data-lang= ' + tmp[0] + ' ]').show();
};

UX.loader.referencesHash = function () {
    var hash = window.location.hash;
    if (hash === '#reference') {
        setTimeout(function () {
            $('.references-tab').click();
        }, 200);
    }
};

UX.loader.captionTruncate = function (elem, lineNumber, show_more, show_less) {
    $(elem).each(function () {
        var $caption = $(this);

        $caption.truncate({
            lines: lineNumber,
            seeMoreLink: true,
            seeMoreText: show_more,
            seeLessText: show_less,
        });
    });
};

UX.figureViewer.additionalBehaviorOnShow = function ($el) {
    var content = null;

    if ($el.find('figcaption .figure__caption').data('originalContent') !== undefined) {
        content = $el.find('figcaption .figure__caption').data('originalContent');
    } else {
        content = $el.find('figcaption, .figcaption').clone();
        content.find('strong').remove();
    }

    videoList = document.querySelectorAll('#figure-viewer .figure__video .cloudflare-stream-player');
    audioList = document.querySelectorAll('#figure-viewer .figure__audio audio');

    UX.loader.videoMedia(videoList, 'figureViewer');
    UX.loader.audioMedia(audioList);

    return content;
};

$(window).on('load resize orientationchange', function () {
    var toTrim = '.article-citation .loa-authors .accordion-tabbed';

    UX.loader.captionTruncate('.tab__content figcaption.figure__caption .figure__caption', 5, 'show', 'hide');
    UX.loader.captionTruncate('.disclosures', 2, 'show', 'hide');
    UX.loader.captionTruncate('.article-header__references-container:not(.no-truncate)', 1, 'More', 'Less');
    UX.loader.captionTruncate('.aboutThisBook .content', 6, 'More', 'Less');

    if (UX.loader.isMobile) {
        $(toTrim).truncate('destroy');
        UX.loader.rebuild.responsive();
        toTrim = '.article-citation .loa.mobile-authors';
        $(toTrim).truncate({
            lines: 2,
            type: 'list',
            seeMoreLink: true,
            seeMoreText: 'See all authors',
            seeLessText: 'See fewer authors',
            lessLinkEllipsis: true,
            isMobile: true,
            mobileTarget: '#sb-1',
            isSliding: true,
        });
    } else {
        $(toTrim).truncate({
            lines: 2,
            type: 'list',
            seeMoreLink: true,
            seeMoreText: 'See all authors',
            seeLessText: 'See fewer authors',
            lessLinkEllipsis: true,
            isSliding: false,
        });
    }

    UX.loader.fixedToolbarPosition();
});

document.addEventListener('mathjax-initilized', () => {
    setTimeout(() => {
        UX.utils.fallbackImageViewer();
    }, 1000);
});
UX.utils.lazyFallbackImage();

UX.loader.load.articleTabs = function () {
    const articleRowRightTabs = UX.utils.convertToArray(document.querySelectorAll('.article-row-right__tabLinks'));

    if (articleRowRightTabs.length) {
        let isLoaded = false;

        const detailsTabLoader = e => {
            if (e.currentTarget.classList.contains('details-tab') && !isLoaded) {
                UX.loader.load.articleTab(
                    UX.loader.details,
                    UX.loader.detailsTab,
                    UX.loader.tabDetails,
                    'details',
                    false,
                    false
                );
                isLoaded = true;
            }
        };

        articleRowRightTabs.forEach(item => {
            ['click', 'focus'].forEach(ev => {
                item.addEventListener(ev, detailsTabLoader);
            });
        });
    }
};

UX.loader.articleTabsTrigger = function () {
    const defaultTabEl = document.querySelector('[data-default-tab]'),
        defaultTabData = defaultTabEl?.dataset.defaultTab,
        pageHash = window.location.hash,
        pubTabs = {
            figures: 'figures',
            references: 'references',
            related: 'related',
            details: 'details',
        },
        setDefaultTab = (selectedTab = '') => {
            let tabBtn, tabBtnParent, tabPane;
            defaultTabEl
                .querySelector(`[class*=${defaultTabEl.getAttribute('data-default-tab')}]`)
                .removeAttribute('tabindex');

            tabBtn = defaultTabEl.querySelector(`.${selectedTab}-tab`);

            if (tabBtn) {
                tabBtnParent = tabBtn.parentElement;
                tabPane = defaultTabEl.querySelector(`[id="pane-pcw-${selectedTab}"]`);
            } else {
                selectedTab = defaultTabData;
                tabBtn = defaultTabEl.querySelector(`.${defaultTabData}-tab`);
                tabBtnParent = tabBtn?.parentElement;
                tabPane = defaultTabEl.querySelector(`[id="pane-pcw-${defaultTabData}"]`);
            }

            if (defaultTabData && !UX.loader.isMobile) {
                tabBtnParent.classList.add('active');
                tabPane.classList.add('active');

                switch (pubTabs[selectedTab]) {
                    case 'figures':
                        UX.loader.load.articleTab(
                            UX.loader.figure,
                            UX.loader.figuresTab,
                            UX.loader.tabFigure,
                            'figure',
                            false,
                            true
                        );
                        break;
                    case 'references':
                        UX.loader.load.articleTab(
                            UX.loader.references,
                            UX.loader.referencesTab,
                            UX.loader.tabReferences,
                            'references',
                            false,
                            true
                        );
                        break;
                    case 'related':
                        UX.loader.load.articleTab(
                            UX.loader.related,
                            UX.loader.relatedTab,
                            UX.loader.tabRelated,
                            'related',
                            false,
                            true
                        );
                        break;
                    case 'details':
                        UX.loader.load.articleTab(
                            UX.loader.details,
                            UX.loader.detailsTab,
                            UX.loader.tabDetails,
                            'details',
                            false,
                            true
                        );
                        break;
                }
            }
        };

    let selectedTab = pageHash === '#reference' ? 'references' : defaultTabEl?.dataset.defaultTab;

    if (defaultTabEl) {
        setDefaultTab(selectedTab);
    }
};

UX.loader.fixedToolbarPosition = function () {
    if ($('.fixedToolbar').length) {
        $('.fixedToolbar').css('top', $('.pageHeader').height());
    }
};

UX.loader.showAudioSupportMsg = function () {
    if (UX.test.isIE() && $('.figure__audio audio').length) {
        $('.figure__audio audio').each(function (index, audio) {
            const $audio = $(audio),
                audioType = $audio.find('source').attr('type');

            if (audioType.indexOf('wav') > -1 || audioType.indexOf('ogg') > -1) {
                $audio.next('.media-error').removeClass('hidden');
                $audio.remove();
            }
        });
    }
};

UX.loader.streamErrorHandler = wrapper => {
    const wrapperEl = document.querySelector(wrapper);

    if (wrapperEl) {
        const streamChildren = wrapperEl.querySelectorAll('.cloudflare-stream-player, audio'),
            mediaError = async e => {
                const parentEl = e.target.closest('.figure__image');
                if (parentEl) {
                    let mediaError = parentEl.querySelector('.media-error'),
                        trackMediaUrlEl = parentEl.dataset.trackMediaUrl,
                        streamAutoplay = e.target.autoplay,
                        eventType = e.type,
                        poster = e.target.attributes.poster.textContent,
                        timeRegex = /time\s*=\s*(\d*)/i,
                        newPoster = poster.replace(timeRegex, 'time=1'),
                        posterChecked = false,
                        url = '';

                    if (trackMediaUrlEl) {
                        url = `${trackMediaUrlEl}&mediaEventType=${eventType}&errorMessage=error&autoplay=${streamAutoplay}`;
                        fetch(url).then(() => false);
                    }

                    if (poster) {
                        posterChecked = await UX.loader.checkPoster(newPoster);

                        if (posterChecked) {
                            return;
                        }
                    }

                    e.target.remove();
                    mediaError?.classList.remove('hidden');
                }
            };

        if (streamChildren.length) {
            streamChildren.forEach(item => {
                item.addEventListener('error', mediaError);
            });
        }
    }
};

UX.loader.checkPoster = async function (poster) {
    try {
        const response = await fetch(poster);

        if (response.status === 200) {
            return true;
        } else {
            throw new Error(`HTTP error: ${response.status}`);
        }
    } catch {
        return false;
    }
};

UX.loader.fixedCoolBar = function () {
    let $fixedCoolBar = $('.fixedCoolBar'),
        coolBarTop = $fixedCoolBar.offset().top,
        coolBarLeft = $fixedCoolBar.offset().left,
        coolBarWidth = $fixedCoolBar.outerWidth(),
        coolBarHeight = $fixedCoolBar.outerHeight();

    if ($(window).scrollTop() > coolBarTop) {
        $fixedCoolBar[0].style.top = '0';
        $fixedCoolBar.css('padding-top', coolBarHeight);
        $fixedCoolBar.find('.stickybar').addClass('js--fixed').css({
            top: 0,
            left: coolBarLeft,
            width: coolBarWidth,
        });
    } else {
        $fixedCoolBar[0].style.top = '0';
        $fixedCoolBar.css('padding-top', '0');
        $fixedCoolBar.find('.stickybar').removeClass('js--fixed').css({
            top: 'auto',
            width: 'auto',
            left: 'auto',
        });
    }
};

UX.loader.seamlessAccessDelay = function () {
    let $seamlessWrapper = $('.seamlessAccessDenial__wrapper'),
        $loader = $seamlessWrapper.find('.js--loader'),
        $text = $seamlessWrapper.find('.text'),
        defaultHref = `/action/ssostart?redirectUri=${encodeURIComponent(`${window.location.pathname}?saml_referrer`)}`;

    if ($loader.length) {
        $text.append(`<a class="temp-link" href="${defaultHref}">(or click to choose manually)</a>`);
    }
};

UX.loader.crossMarkAccessibility = function () {
    const crossMarkTrigger = document.querySelector('.crossMarkTrigger');
    if (crossMarkTrigger) {
        const iframeAccessibility = e => {
            const rand = Math.floor(Math.random() * 10),
                crossMarkInit = () => {
                    const crossMarkIframe = UX.utils.convertToArray(
                            document.querySelectorAll('iframe.crossmark-popup__content')
                        ),
                        crossMarkClassList = {
                            currentIndex: 'js--currentIndex',
                            fakeFocusEl: 'js--fakeFocus',
                        },
                        closeModalOnEsc = e => {
                            if (e.key.includes('Esc')) {
                                const crossMarkWidget = document.getElementById('crossmark-widget');
                                if (crossMarkWidget && crossMarkWidget.style.display === 'block') {
                                    crossMarkWidget.style.display = 'none';
                                    const focusTriggerTargetEl = document.querySelector(`.crossMarkTrigger.js--opened`);
                                    focusTriggerTargetEl?.focus();
                                    focusTriggerTargetEl?.classList.remove('js--opened');
                                }
                            }
                        },
                        crossMarkCloseBtn = e => {
                            const focusTriggerTargetData = e.target.dataset.focusTriggerTarget,
                                focusTriggerTargetEl = document.querySelector(
                                    `.crossMarkTrigger[data-focus-trigger="${focusTriggerTargetData}"]`
                                );
                            focusTriggerTargetEl?.focus();
                            focusTriggerTargetEl?.classList.remove('js--opened');
                        };

                    if (crossMarkIframe.length) {
                        crossMarkIframe.forEach(item => {
                            item.title = 'CrossMark';
                            const wrapper = item.closest('#crossmark-widget');

                            if (wrapper) {
                                if (wrapper.style.display === 'block') {
                                    const logo = wrapper.querySelector('.crossmark-popup__logo'),
                                        inner = wrapper.querySelector('.crossmark-popup__inner'),
                                        footer = wrapper.querySelector('.crossmark-popup__footer'),
                                        fakeFocusEl = document.createElement('div'),
                                        closeBtn = wrapper.querySelector('.crossmark-popup__btn-close'),
                                        footerContent = `
                                                <div class="crossmark-popup__footer">
                                                    <div class="crossmark-popup__footer-right">
                                                        <a href="http://crossmark.crossref.org/" target="_blank">Help</a>
                                                    </div>
                                                </div>
                                            `;

                                    wrapper.setAttribute('tabindex', '-1');
                                    wrapper.setAttribute('role', 'dialog');
                                    wrapper.setAttribute('aria-label', 'CrossMark dialog');

                                    if (closeBtn) {
                                        closeBtn.focus();
                                        closeBtn.classList.add(crossMarkClassList.currentIndex);
                                        closeBtn.setAttribute('aria-label', 'Close dialog');
                                        closeBtn.dataset.focusTriggerTarget = `${rand}`;
                                    }

                                    fakeFocusEl.classList.add(crossMarkClassList.fakeFocusEl);
                                    fakeFocusEl.setAttribute('tabindex', '0');
                                    fakeFocusEl.setAttribute('aria-hidden', 'true');

                                    if (inner) {
                                        if (!footer) {
                                            inner.insertAdjacentHTML('beforeend', footerContent);
                                            const popupContentWrapper = inner.querySelector(
                                                    '.crossmark-popup__content-wrapper'
                                                ),
                                                popupFooter = inner.querySelector('.crossmark-popup__footer');

                                            popupContentWrapper.style.paddingBottom = `${
                                                popupFooter ? `${popupFooter.offsetHeight}px` : ''
                                            }`;
                                        }
                                        inner.appendChild(fakeFocusEl);
                                    }
                                    logo?.parentElement.setAttribute('aria-label', 'Crossmark logo');

                                    const focusableList = UX.utils.convertToArray(
                                        wrapper.querySelectorAll(
                                            'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
                                        )
                                    );

                                    if (focusableList.length) {
                                        focusableList.forEach((item, index) => {
                                            item.dataset.focusOrder = index;

                                            item.addEventListener('focus', e => {
                                                const oldElFocusOrder = wrapper?.querySelector(
                                                    `.${crossMarkClassList.currentIndex}`
                                                )?.dataset.focusOrder;

                                                focusableList.map(el =>
                                                    el.classList.remove(crossMarkClassList.currentIndex)
                                                );

                                                e.target.classList.add(crossMarkClassList.currentIndex);

                                                if (e.target.classList.contains(crossMarkClassList.fakeFocusEl)) {
                                                    const newFocusOrder = e.target.dataset.focusOrder;
                                                    if (newFocusOrder > oldElFocusOrder) {
                                                        focusableList[0].focus();
                                                    }
                                                }
                                            });
                                        });

                                        focusableList[0].addEventListener('focusout', e => {
                                            if (
                                                e.relatedTarget &&
                                                typeof e.relatedTarget.dataset.focusOrder === 'undefined'
                                            ) {
                                                focusableList[focusableList.length - 2].focus();
                                            }
                                        });
                                    }
                                } else {
                                    wrapper.parentElement.removeChild(wrapper);
                                }
                            }
                        });
                    }

                    const crossMarkPopupClose = UX.utils.convertToArray(
                        document.querySelectorAll('.crossmark-popup__btn-close')
                    );
                    if (crossMarkPopupClose.length) {
                        crossMarkPopupClose.forEach(item => item.addEventListener('click', crossMarkCloseBtn));
                    }

                    document.addEventListener('keydown', closeModalOnEsc);
                };

            e.currentTarget.dataset.focusTrigger = `${rand}`;
            e.currentTarget.classList.add('js--opened');

            setTimeout(crossMarkInit);
        };

        crossMarkTrigger.addEventListener('click', iframeAccessibility);
    }
};

UX.loader.altMetricLoader = function () {
    const altMetricEl = document.querySelector('.altmetric-embed');
    if (altMetricEl) {
        /* eslint-disable */
        const altMetricChecker = () => {
            const altMetricTrigger = altMetricEl.querySelector('a[data-badge-popover]'),// this is null when score == 0
                numberOfDownloads = document.querySelector(".number-of-downloads"),
                citedByCount = document.querySelector(".cited-by-count");

            if (altMetricTrigger || numberOfDownloads || citedByCount) {
                clearInterval(altMetricInterval);
                const metricsOuterWrapper = document.querySelector('.metrics'),
                    altMetricImage = altMetricTrigger?.querySelector('img'),
                    imageAlt = altMetricImage?.alt,
                    altMetricImageParent = metricsOuterWrapper?.querySelector('.altmetric-embed'),
                    isScoreZero = !(altMetricImage?.closest('.altmetric-embed')),
                    uuid = altMetricImageParent?.dataset.uuid,
                    altMetricPopover = document.querySelector(`.altmetric-popover[data-uuid="${uuid}"]`),
                    altMetricPopoverInner = altMetricPopover?.querySelector('.altmetric-popover-content'),
                    mouseOutEvent = new Event('mouseout'),
                    mouseOverEvent = new Event('mouseover'),
                    fakeFocusable = '<div class="sr-only js--adFocusableEl" aria-hidden="true" tabindex="0"></div>',
                    backToLink =
                        '<a href="javascript:void(0)" role="button" aria-label="back to altmetric link" class="sr-only js--backToLink"></a>',
                    wSlide = document.querySelector('.w-slide'),
                    wSlideContent = document.querySelector('.w-slide__content'),
                    setTriggerAttributes = el => {
                        el.setAttribute('role', 'button');
                        el.setAttribute('aria-expanded', 'false');
                        el.setAttribute('id', 'altMetric');
                        el.setAttribute('aria-label', imageAlt);
                        el.setAttribute('href', 'javascript:void(0)');
                    },
                    closePopover = () => {
                        altMetricTrigger?.dispatchEvent(mouseOutEvent);
                        altMetricTrigger?.focus();
                        altMetricTrigger?.setAttribute('aria-expanded', 'false');
                        UX.tooltip.on.checkToHide();
                    },
                    triggerClickHandler = e => {
                        e.preventDefault();
                        e.target.dispatchEvent(mouseOverEvent);
                        altMetricTrigger?.setAttribute('aria-expanded', 'true');
                        if (altMetricPopoverInner) {
                            setTimeout(() => {
                                const fakeFocusableEl = altMetricPopover.querySelector('.js--adFocusableEl'),
                                    backToLinkEl = altMetricPopover.querySelector('.js--backToLink'),
                                    backToLinkHandler = e =>
                                        e.target.classList.contains('js--backToLink') && closePopover();

                                altMetricPopoverInner.setAttribute('tabindex', '-1');
                                altMetricPopoverInner.focus();
                                !backToLinkEl && altMetricPopoverInner.insertAdjacentHTML('beforeend', backToLink);
                                !fakeFocusableEl && altMetricPopoverInner.insertAdjacentHTML('afterend', fakeFocusable);

                                altMetricPopoverInner.addEventListener('click', backToLinkHandler);
                            }, 350);
                        }
                    },
                    focusOutHandler = e =>
                        e.relatedTarget && !e.relatedTarget.closest('.altmetric-popover-content') && closePopover(),
                    popoverEscapeHandler = e => e.key === 'Escape' && closePopover(),
                    EscapeMouseOver = () => {
                        const bodyKeyDownHandler = e => {
                            if (e.key === 'Escape' && altMetricPopover.style.display === 'block') {
                                altMetricTrigger?.dispatchEvent(mouseOutEvent);
                            }
                        };
                        document.body.addEventListener('keydown', bodyKeyDownHandler);
                    };

                if (citedByCount || numberOfDownloads || altMetricImageParent) metricsOuterWrapper.classList.add('js--show');
                if (isScoreZero) {
                    altMetricEl.classList.add("js--hide");
                }
                altMetricTrigger && setTriggerAttributes(altMetricTrigger);
                altMetricTrigger?.addEventListener('click', triggerClickHandler);
                altMetricTrigger?.addEventListener('mouseover', EscapeMouseOver);
                wSlide.addEventListener('click', closePopover);
                wSlideContent.addEventListener('scroll', closePopover)

                if (altMetricPopoverInner) {
                    altMetricPopoverInner.setAttribute('aria-labelledby', altMetricTrigger?.id);
                    altMetricPopoverInner.setAttribute('id', `${altMetricTrigger?.id}-${uuid}`);
                    altMetricTrigger?.setAttribute('aria-controls', altMetricPopoverInner.id);
                    altMetricPopoverInner.addEventListener('focusout', focusOutHandler);
                    altMetricPopoverInner.addEventListener('keydown', popoverEscapeHandler);
                }
            } else if (intervalCounter === 60000) {
                clearInterval(altMetricInterval);
            }
            intervalCounter += 500;
        };
        let altMetricInterval = setInterval(altMetricChecker, 500),
            intervalCounter = 0;
        /* eslint-enable */
        UX.utils.fallbackImageViewer();
    }
};

UX.loader.removeGetFTRElement = elements => {
    elements.forEach(element => {
        if (element.textContent.trim() === '') {
            const nextElement = element.nextElementSibling;
            const firstLinkEl = nextElement?.nextElementSibling;
            firstLinkEl?.classList.add('first-link');
            nextElement?.classList.contains('getFTR__content') && nextElement.remove();
        }
    });
};
